import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=544a8a26&"
import script from "./DropdownUser.vue?vue&type=script&lang=js&"
export * from "./DropdownUser.vue?vue&type=script&lang=js&"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports